export const generateMarks = (
  min: number,
  max: number,
  step: number,
  labelEvery: number = 1
) =>
  Array.from({ length: Math.floor((max - min) / step) + 1 }, (_, i) => {
    const value = min + i * step;
    return {
      value,
      label: i % labelEvery === 0 ? `${value}` : '',
    };
  });
